<template>
  <v-btn variant="text" rounded elevation="0" class="pa-0 text-medium-emphasis" height="32">
    <slot />
  </v-btn>
</template>

<style lang="scss" scoped>
.v-btn--active.v-btn.v-btn--rounded {
  color: rgb(var(--v-theme-primary)) !important;
}
</style>
